module.exports = "<footer class=\"footer text-muted text-center mt-4\">\n    &copy; 2007-2019 Boston Children's Hospital\n</footer>\n"